import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
import IntlyVideo from 'components/intly-video';
import lib from './components/lib';
import Context from './components/Context';
import IntlyPaddle from './components/intly-paddle';

let addContext = [(el) => IntlyPaddle(el)];

document.addEventListener('DOMContentLoaded', () => {
    new Context({ target: '.paddle-parent' }, addContext);
});


// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function($) {
    Components.init();
    Plugins.init();
});



lib.qsa('.has-background.has-primary-background-color, .has-background.has-grey-background-color, .has-background.has-tertiary-background-color').forEach(el => {
    el.classList.add('box-expand');
    el.classList.add('--viewport');
   
    // create element and append the expander
    let expander = document.createElement('div');
    expander.classList.add('--expander');
    expander.classList.add('z-0');
    el.appendChild(expander);
});


// Function to handle intersection changes
// -- START Intersection Observer
const handleIntersection = (entries, observer) => {
    entries.forEach(entry => {
        let element = entry.target;
        if (entry.isIntersecting) {
            element.classList.add('--in-viewport');
            element.classList.add('--has-viewport');
        } else {
            element.classList.remove('--in-viewport');
        }
    });
}

// Initialize Intersection Observer
let observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.1 
});

// Observe Elements
let elementsToObserve = document.querySelectorAll('.--viewport');
elementsToObserve.forEach(element => {
    observer.observe(element);
});
// -- END Intersection Observer


// Initialize Vimeo
document.querySelectorAll(".intly-video").forEach((root) => {
    new IntlyVideo(root);
});




// Start INLINE VIDEO // MP4 ONlY
const videos = lib.qsa('.inline-video');

videos.forEach(function(videoContainer) {
    const video = videoContainer.querySelector('video');
    const playButton = videoContainer.querySelector('.play-btn');
    const pauseButton = videoContainer.querySelector('.pause-btn');


    pauseButton.style.display = 'none';

    // Play button click event
    playButton.addEventListener('click', function(e) {
        e.preventDefault();
        video.play(); 
        playButton.style.display = 'none';
        pauseButton.style.display = 'flex';
    });

    // Pause button click event
    pauseButton.addEventListener('click', function(e) {
        e.preventDefault(); 
        video.pause();
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none'; 
    });
});
// END INLINE VIDEO







function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( jQuery(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}



/* All Anchor Links */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetID = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById('#' + targetID);

        console.log(targetElement);

        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});
/* END */